module.exports = __webpack_public_path__ + "img/share-button-en.40538062.png";